export default __webpack_public_path__ + "static/media/letter-spacing-gestalt.1321c15e.svg";